import type {
  CreateClientPayoutBatchDto,
  PayoutBatchDto,
  UpdateClientPayoutBatchItemsDto,
} from '@paladin-monorepo/common';
import API from '../api';

export const clientPayoutBatchesApi = {
  list(): Promise<PayoutBatchDto[]> {
    return API.get<PayoutBatchDto[]>('/client/payout-batches').then((r) => r.data);
  },

  get(id: string): Promise<PayoutBatchDto> {
    return API.get<PayoutBatchDto>(`/client/payout-batches/${encodeURIComponent(id)}`).then((r) => r.data);
  },

  create(body: CreateClientPayoutBatchDto): Promise<PayoutBatchDto> {
    return API.post<PayoutBatchDto>('/client/payout-batches', body).then((r) => r.data);
  },

  updateItems(id: string, body: UpdateClientPayoutBatchItemsDto): Promise<PayoutBatchDto> {
    return API.patch<PayoutBatchDto>(`/client/payout-batches/${encodeURIComponent(id)}/items`, body).then(
      (r) => r.data,
    );
  },

  submitForApproval(id: string): Promise<PayoutBatchDto> {
    return API.post<PayoutBatchDto>(
      `/client/payout-batches/${encodeURIComponent(id)}/submit-for-approval`,
    ).then((r) => r.data);
  },

  approve(id: string): Promise<PayoutBatchDto> {
    return API.post<PayoutBatchDto>(`/client/payout-batches/${encodeURIComponent(id)}/approve`).then((r) => r.data);
  },

  async exportAbo(id: string): Promise<void> {
    const res = await API.post<string>(
      `/client/payout-batches/${encodeURIComponent(id)}/export-abo`,
      {},
      { responseType: 'text' },
    );
    const disposition = res.headers['content-disposition'] as string | undefined;
    const match = disposition?.match(/filename="([^"]+)"/);
    const filename = match?.[1] ?? `payout-${id}.abo`;
    const blob = new Blob([res.data], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  },
};
